  import {} from 'ramda'

  class Analytics {
    /* @ngInject */
    constructor ($mdSidenav, $mdDialog, $rootScope, Auth, $state, $mdToast, $window, $mdMedia, $ocLazyLoad, moment, analytics, $sce) {
      this.analytics = $sce.trustAsResourceUrl(analytics.url)
      this.reviews = analytics.reviews
      this.ratings = analytics.ratings[0]
      if (analytics.ratings.length) {
        this.ratings.average = this.ratings.average.toFixed(2)
        this.starTotal = Math.floor(this.ratings.average)
        this.starRemainder = this.ratings.average - this.starTotal
      }
      this.showBadge = false
      this.badge125 = '<a href="https://bluecrewjobs.com"><img style="width:125px; height:125px" src="https://bluecrewjobs.com/images/bluecrew_top_employer_2017_badge.png" alt="BlueCrew Top Employer 2017></a>'
      this.badge70 = '<a href="https://bluecrewjobs.com"><img style="width:70px; height:70px" src="https://bluecrewjobs.com/images/bluecrew_top_employer_2017_badge.png" alt="BlueCrew Top Employer 2017></a>'
      this.$window = $window
    }

  }

  export default Analytics
